const BREAKPOINT = 1024
export const setupMenu = () => {
  // 1024
  const headerMenu = document.getElementById("header-menu")
  const menuTrigger = document.getElementById("header-menu-trigger")
  const menuTriggerOpen = document.getElementById("header-menu-trigger-open")
  const menuTriggerClose = document.getElementById("header-menu-trigger-close")

  menuTrigger.addEventListener("click", (e) => {
    e.preventDefault()
    if (headerMenu.classList.contains("hidden")) {
      headerMenu.classList.remove("hidden")

      menuTriggerOpen.classList.add("hidden")
      menuTriggerClose.classList.remove("hidden")
    } else {
      headerMenu.classList.add("hidden")

      menuTriggerOpen.classList.remove("hidden")
      menuTriggerClose.classList.add("hidden")
    }
  })

  if (window.innerWidth < BREAKPOINT) {
    // zwin menu
    headerMenu.classList.add("hidden")

    menuTriggerOpen.classList.remove("hidden")
    menuTriggerClose.classList.add("hidden")
  } else {
    headerMenu.classList.remove("hidden")
    // pokaz burger

    menuTriggerOpen.classList.add("hidden")
    menuTriggerClose.classList.remove("hidden")
  }
}
